<app-loading *ngIf="contentReady"></app-loading>
<div style="padding: 0 15px">
  <div class="row mb-4">
    <div class="col-12 col-md-12 category infoContainer" [ngClass]="{ categoryAr: classToggled }">
      <div class="meun d-flex align-items-center flex-column gap-1">

        <img class="profilepic" [src]="userimage" alt="" />


        <h5 style="color: rgba(0, 0, 0, 0.5)">
          {{ "welcome" | translate }}
          :
          {{userfirstname}}
        </h5>
      </div>
      <div class="userInfo">

        <p>{{"username" | translate}}: {{userName}}</p>
        <p>{{"phone" | translate}} :{{userPhone}}</p>
        <p>
          <a [href]="userInstgram">
            {{"instagram" | translate}}
          </a>
        </p>
        <p>
          <a [href]="userFacebook">
            {{"facebook" | translate}} </a>
        </p>
        <p>
          <a [href]="userTiktok"> {{"tiktok" | translate}}</a>
        </p>
        <p>
          <a routerLink="/change-password">{{
            "Change Password" | translate
            }}</a>
        </p>
      </div>
    </div>

  </div>
</div>